import moment from 'moment/moment';
import { CalendarView } from '../calendarWrapper/CalendarWrapper';

export const calculateFetchGap = (currentDate: string, calendarView: CalendarView) => {
  const startOfWeek = moment(currentDate).startOf('week');
  const startOfMonth = moment(currentDate).startOf('month');
  switch (calendarView) {
    case CalendarView.DAY:
    case CalendarView.AREAS:
      return [
        moment(currentDate).subtract(1, 'month').startOf('month'),
        moment(currentDate).add(1, 'month').endOf('month'),
      ];
    case CalendarView.THREE_DAY:
      return [
        moment(currentDate).subtract(1, 'month').startOf('month'),
        moment(currentDate).add(1, 'month').endOf('month'),
      ];
    case CalendarView.WEEK:
      return [
        moment(startOfWeek).subtract(1, 'month').startOf('month'),
        moment(startOfWeek).add(1, 'month').endOf('month'),
      ];
    case CalendarView.MONTH:
      return [
        moment(startOfMonth).subtract(1, 'month').subtract(1, 'week'),
        moment(startOfWeek).add(1, 'month').add(1, 'week'),
      ];
    case CalendarView.CONDENSED:
      return [moment(startOfMonth).subtract(3, 'month').subtract(1, 'week'), moment(startOfWeek).add(12, 'month')];
    default:
      return [moment(currentDate), moment(currentDate).add(1, 'month')];
  }
};
